export const REQUEST_DASHBOARD_USER_EVENTS_STATISTICS =
  "REQUEST_DASHBOARD_USER_EVENTS_STATISTICS";
export const REQUEST_DASHBOARD_USER_EVENTS_STATISTICS_DONE =
  "REQUEST_DASHBOARD_USER_EVENTS_STATISTICS_DONE";

export interface FetchDashboardUserEventsStatistics {
  type: typeof REQUEST_DASHBOARD_USER_EVENTS_STATISTICS;
  payload: any[];
}

export interface FetchDashboardUserEventsStatisticsDone {
  type: typeof REQUEST_DASHBOARD_USER_EVENTS_STATISTICS_DONE;
  payload: any[];
}

export interface DashboardUserEventsStatisticsState {
  isLoading: boolean;
  userEvents: any[];
}

export type DashboardUserEventsStatisticsActions =
  | FetchDashboardUserEventsStatistics
  | FetchDashboardUserEventsStatisticsDone;
